import React, { useEffect } from 'react';

const Darkmode = () => {
    let theme;
    const switchTheme = (newTheme = null) => {
        if (newTheme) {
            theme = newTheme;
            document.body.classList.remove("light");
            document.body.classList.remove("dark");
            document.body.classList.add(newTheme);
            localStorage.setItem("theme", newTheme);
        } else {
            switch (theme) {
                case "light":
                    document.body.classList.replace("light", theme = "dark");
                    localStorage.setItem("theme", theme);
                    break;
                case "dark":
                default:
                    document.body.classList.replace("dark", theme = "light");
                    localStorage.setItem("theme", theme);
                    break;
            }
        }
    }
    
    useEffect(() => {
        switchTheme(localStorage.getItem("theme") ?? "light");
    });

    return (
        <button id="darkmode" onClick={() => switchTheme()}>
           <img className="light-icon" src={`${process.env.PUBLIC_URL}/images/icons/sun-01.svg`} alt="Sun images" />
           <img className="dark-icon" src={`${process.env.PUBLIC_URL}/images/icons/vector.svg`} alt="Sun images" />
        </button>
    )
}
export default Darkmode;